export default {"src":"/_next/static/media/21-icon.9f45134d.svg","height":46,"width":40,"blurWidth":0,"blurHeight":0};